import HelperMixin from '../../Shared/HelperMixin.vue'

export default {
    name: 'Login',
    mixins: [HelperMixin],
    components: {
    },
    created() {
        this.$blockUI.$loading = this.$loading;
        this.logout();
    },
    data() {
        return {
            isAuthenticated: false,
            isActive: false,
            form: {
                Password: null,
                Email: null
            }
        };
    },

    mounted() {
        const loadScript = (src) => {
            document.body.appendChild(
                Object.assign(document.createElement('script'), { src: src, async: false })
            );
        };

        loadScript('./assets/vendor/libs/jquery/jquery.js');
        loadScript('./assets/vendor/libs/popper/popper.js');
        loadScript('./assets/vendor/js/bootstrap.js');
        loadScript('./assets/vendor/libs/node-waves/node-waves.js');
        loadScript('./assets/vendor/libs/perfect-scrollbar/perfect-scrollbar.js');
        loadScript('./assets/vendor/libs/hammer/hammer.js');
        loadScript('./assets/vendor/libs/i18n/i18n.js');
        loadScript('./assets/vendor/libs/typeahead-js/typeahead.js');
        loadScript('./assets/vendor/js/menu.js');
        loadScript('./assets/vendor/libs/@form-validation/popular.js');
        loadScript('./assets/vendor/libs/datatables-bs5/datatables-bootstrap5.js');
        loadScript('./assets/js/main.js');
        loadScript('./assets/vendor/libs/@form-validation/auto-focus.js');
        loadScript('./assets/vendor/libs/sweetalert2/sweetalert2.js');
        loadScript('./assets/js/pages-auth.js');
        //loadScript('./assets/vendor/libs/block-ui/block-ui.js');
    },

    methods: {



        GoToPlatform() {
            window.location.href = 'https://platform.test.traneem.ly/';
            //window.href('https://platform.test.traneem.ly/');
        },


        logout() {



            localStorage.removeItem('currentUser-client');
            document.cookie.split(";").forEach(function (c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); });
            this.$blockUI.Start();
            this.$http.Logout()
                .then(() => {
                    this.$blockUI.Stop();
                    //  window.location.href = "/Login";
                })
                .catch((err) => {
                    this.$blockUI.Stop(err);
                    //console.error(err);
                });
        },

        login() {



            if (!this.form.Email) {
                this.$helper.ShowMessage('error', 'عملية ناجحة', '<strong>' + 'الرجاء إدخال البريد الإلكتروني' + '</strong>');
               
            }
            if (!this.form.Password) {
                this.$helper.ShowMessage('error', 'عملية ناجحة', '<strong>' + 'الرجاء إدخال الرقم السري' + '</strong>');
            }

            //this.Loading = true;
            this.$blockUI.Start();
            this.$http.login(this.form)
                .then(response => {
                    //debugger;
                    this.$blockUI.Stop();
                    localStorage.setItem('currentUser-client', this.encrypt(JSON.stringify(response.data), this.PlatFormPass));
                    // جولة التعريف تُعرض مرة واحدة بعد أول تسجيل دخول (انظر Shared/firstLoginTour.js)
                    try {
                        sessionStorage.setItem('mso_fresh_login', '1');
                    } catch (e) { /* ignore */ }
                    const d = response.data || {};
                    let permissionsList = [];
                    try {
                        if (d.permissions) {
                            const parsed = JSON.parse(d.permissions);
                            if (Array.isArray(parsed)) {
                                permissionsList = parsed;
                            }
                        }
                    } catch (e) { /* ignore */ }

                    const hasMinisterDashboardAccess = permissionsList.some(x => String(x).toLowerCase() === 'minister_dashboard.access');
                    // مكتب تقنية المعلومات المتخصص: وزاري صلاحياته system_users.manage فقط → يهبط على شاشة المستخدمين
                    const isItOfficeOnly = Number(d.userType) === 40
                        && permissionsList.length > 0
                        && permissionsList.every(x => String(x).toLowerCase() === 'system_users.manage');
                    const ut = Number(d.userType);
                    const branchId = d.branchesId != null && d.branchesId !== '' ? Number(d.branchesId) : null;
                    const isFacilityGate = !!(branchId && [2, 5, 6].includes(ut));
                    const rawSt = d.facilityOnboardingStatus ?? d.FacilityOnboardingStatus;
                    const st = rawSt != null && rawSt !== '' ? Number(rawSt) : null;
                    const stOk = st != null && !Number.isNaN(st) ? st : null;
                    let landing = '/Home';
                    if (hasMinisterDashboardAccess) {
                        landing = '/Dashboard';
                    } else if (isItOfficeOnly) {
                        landing = '/Users';
                    } else if (isFacilityGate && stOk === 1) {
                        landing = '/InventoryCounts';
                    } else if (isFacilityGate && stOk === 2) {
                        landing = '/FacilityOnboarding/AwaitingPharmacyReview';
                    } else if (isFacilityGate && stOk === 3) {
                        landing = '/FacilityOnboarding/AwaitingMinistryApproval';
                    }
                    window.location.href = landing;
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('error', 'خطاء بعملية الاضافة', err.response.data);
                  
                });
        }



    }
}
